(function () {
  'use strict';

  angular.module('tfc.retailer.StandardReports')
      .factory('DateUtil', DateUtils);

  function DateUtils() {

    return {
      fullMonthDate : function(d) { return moment(d).format('MMMM D, YYYY');},
      shortMonthDate: function (d) { return moment(d).format('MMM D, YYYY');},
      onlyMonth: function (d) { return moment(d).format('MMM YYYY');},
      shortMonthDateWithDayOfWeek: function (d) { return moment(d).format('ddd MMM D, YYYY');},
      formatToYearMonthDay: function(d) { return moment(d).format('YYYY-MM-DD');}
    }
  }
})();